exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blog-post .link.prev{float:left}.blog-post .link.next{float:right}.blog-post .date,.blog-post .title{text-align:center;margin:0;padding:0}.blog-post .date{color:#555;margin-bottom:1rem}.blog-post .navigation{min-height:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/css/blog-post.css
// module id = ./src/css/blog-post.css
// module chunks = 1